import { HTML_INPUT_TIME_FORMAT } from '@/config/time.js'
import dateUtil from '../utils/date_util'

export default {
  computed: {
    theme() {
      if (this.client === 'android' || this.client === 'ios') {
        return 'app'
      } else {
        return 'wechat-mini'
      }
    },
    isMiniprogram() {
      return this.$route.query.client !== 'android' && this.$route.query.client !== 'ios'
    }
  },
  methods: {
    /**
     * 是否空
     *
     * @param {string|number|Array|object} obj 需要判断的内容
     * @returns {boolean} 是否空内容
     */
    isEmptyObject(obj) {
      for (let name in obj) {
        return false
      }

      if (typeof obj === 'number' || typeof obj === 'boolean') return false // 如果是数值 或者布尔值，都不能认为是空
      return true
    },
    /**
     * 剩余多少天
     *
     * @param {string} end_time 结束时间
     * @returns {string} 天数
     */
    date2Duration(end_time) {
      let durationTime = this.$dayjs.duration(this.$dayjs(end_time).valueOf() - this.$dayjs(this.currentDate).valueOf())
      let months = durationTime.months()
      let days = durationTime.days()
      let hours = durationTime.hours()
      let minutes = durationTime.minutes()
      if (durationTime.seconds() >= 0) {
        if (months > 0) {
          return `${months > 0 ? months + '个月' : ''}${days > 0 ? days + '天' : ''}`
        } else if (days > 0) {
          return `${days > 0 ? days + '天' : ''}${hours > 0 ? hours + '小时' : ''}`
        } else {
          return `${hours > 0 ? hours + '小时' : ''}${minutes}分钟`
        }
      } else {
        return '已过期'
      }
    },
    /**
     * 普通日期格式化
     *
     * @param {Date} date 日期
     *
     * @returns {string} 返回格式化以后的值
     *  */

    formatTime(date = null) {
      if (date == null || date == '' || typeof date == 'undefined') {
        return '-'
      } else if (typeof date == 'object') {
        return date
      } else {
        if (date.indexOf('+0800') > -1) {
          return this.$dayjs(this.replaceTimeStr(date)).format(HTML_INPUT_TIME_FORMAT)
        } else {
          return this.$dayjs(date).format(HTML_INPUT_TIME_FORMAT)
        }
      }
    },
    // 格式化数字类型 eg: 10000 to 10,000
    formatThousands(number = 0) {
      number = typeof number === 'string' ? parseFloat(number) : number
      return number.toLocaleString('en')
    },
    /**
     * 格式化时间
     *
     * @param {string} date iso time
     * @returns {string} 格式化
     */
    ts(date) {
      return this.formatTime(date)
    },
    /**
     * 距离当前时间的展示
     *
     * @param {string} date iso time
     * @returns {string} 时间距离的表达
     */
    fromNow(date) {
      return dateUtil.formatFormTime(date)
    },
    /**
     * 文本展示
     * 空的时候展示 -
     *
     * @param {?string} text 文本
     * @returns {string} 展示的文本
     */
    txt(text) {
      if (this.isEmptyObject(text)) {
        return '-'
      }
      return text
    }
  }
}
